import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Registrations } from "@/types";
import { saveRegistrations } from "./thunk";

export interface RegistrationsState {
  registrations: Partial<Registrations>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
  isRegisteredSuccessfully: boolean;
}

const initialState: RegistrationsState = {
  registrations: {},
  error: null,
  status: "idle",
  isRegisteredSuccessfully: false
};

export const registrationsSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetRegistrations: (state) => {
      state.isRegisteredSuccessfully = initialState.isRegisteredSuccessfully;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[registrationsSlice.name]
        };
      })
      .addCase(saveRegistrations.pending, (state) => {
        state.status = "saving";
      })
      .addCase(saveRegistrations.fulfilled, (state, action) => {
        state.status = "idle";
        state.registrations = action.payload;
        state.isRegisteredSuccessfully = true;
      })
      .addCase(saveRegistrations.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
        state.isRegisteredSuccessfully = false;
      });
  }
});

export const { resetRegistrations } = registrationsSlice.actions;
